export default function () {
  // reativando com do usuario e mostrando modal de bem vindo
  this.doActive()
  this.doUpdateSetting()
}



// WEBPACK FOOTER //
// ./src/app/professional/dashboard/company/gadget/resources/mounted.js